import object from 'helpers/object'


export const initialState = {
  step: 'tariff',
  stepData: null,
  labels: [],
  tariffs: [],
  schedule: [],
  services: [],
  categories: [],
  total: null,
  isTotalFetching: true,
  isFetching: true,
}


export const setStep = (state, payload) => (
  object.setIn(state, [ 'step' ], payload)
)

export const setStepData = (state, payload) => (
  object.setIn(state, [ 'stepData' ], payload)
)

export const setLabels = (state, payload) => (
  object.setIn(
    state,
    [ 'labels' ],
    payload
    // payload.sort((a, b) => (
    //   a.lbl > b.lbl
    //     ? 1
    //     : a.lbl < b.lbl
    //     ? -1
    //     : 0
    // ))
  )
)

export const setTariffs = (state, payload) => (
  object.setIn(state, [ 'tariffs' ], payload)
)

export const setServices = (state, payload) => (
  object.setIn(state, [ 'services' ], payload)
)

export const setCategories = (state, payload) => (
  object.setIn(state, [ 'categories' ], payload)
)

export const updateSchedule = (state, payload) => (
  object.setIn(state, [ 'schedule' ], [ ...state.schedule.concat(payload) ])
)

export const setTotal = (state, payload) => (
  object.setIn(state, [ 'total' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setTotalFetching = (state, payload) => (
  object.setIn(state, [ 'isTotalFetching' ], payload)
)

export const resetSchedule = (state) => (
  object.setIn(state, [ 'schedule' ], [])
)
